import React, { useCallback } from 'react'
import { useApp } from '../../../context/AppProvider'
import { filterBlockByType } from '../../../services/common'
import InputRadio from '../what-is-your-situation/InputRadio'

const Problematic = ({ block, index }) => {
    const blockTitle = filterBlockByType(block?.childrens, 'Titre')
    const helpBlock = filterBlockByType(block?.childrens, 'Aide')
    const { constructAffectTrueValue, setSelectedValue, selectedValue } = useApp()

    const onChange = (e) => {
        e.preventDefault()
        let hash = window.location.hash.substring(1)
        if (hash) {
            hash += '_' + index
        } else {
            hash = index.toString()
        }
        window.history.pushState({}, '', '#' + hash)
    }

    const renderChoice = useCallback(() => {
        const label = filterBlockByType(block?.childrens, 'Titre')
        const linkInternal = filterBlockByType(block?.childrens, 'LienInterne')
        const affectTrue = constructAffectTrueValue(block)
        return {
            label: label?.content,
            intituleSiSelectionne: label?.content,
            affectTrue,
            linkInternal,
            index: index,
            id: block.ID,
            helpBlock: helpBlock ? helpBlock : null,
        }
    }, [block, helpBlock, constructAffectTrueValue])

    return (
        <div className="baseocom-block-problematic what-is-your-situation-choice-container">
            <InputRadio
                type="problematic"
                title={blockTitle?.content}
                value={block}
                choice={renderChoice()}
                onChange={onChange}
                helpBlock={helpBlock}
            />
        </div>
    )
}

export default Problematic
